import React, { useEffect, useState } from "react";

const UserScheduleAppointmentPopup = ({ onClose, firebase, doctorEmail }) => {
  const userEmail = firebase.auth.currentUser.email;
  const today = new Date();

  const [weekOffset, setWeekOffset] = useState(0);
  const [availableSlots, setAvailableSlots] = useState({});
  const [requestedSlots, setRequestedSlots] = useState({});
  const [userCurrentRequest, setUserCurrentRequest] = useState(null);
  const [confirmedPopup, setConfirmedPopup] = useState(null); // ✅ NEW

  /* ✅ FETCH PROVIDER AVAILABILITY */
  useEffect(() => {
    const fetchAvailability = async () => {
      const doc = await firebase.db
        .collection("providerAvailability")
        .doc(doctorEmail)
        .get();

      if (doc.exists && doc.data()?.availableSlots) {
        setAvailableSlots(JSON.parse(doc.data().availableSlots));
      }
    };

    fetchAvailability();
  }, [firebase, doctorEmail]);

  /* ✅ FETCH REQUESTED + CONFIRMED — CANCELLED HIDDEN */
  useEffect(() => {
  if (!doctorEmail) return;

  const todayStr = new Date().toISOString().split("T")[0];
  const todayDate = new Date(`${todayStr}T00:00:00`);

  const unsub = firebase.db
    .collection("appointmentSchedules") // no filters
    .onSnapshot(
      (snap) => {
        const allReq = {};
        let mySlot = null;

        snap.docs.forEach((doc) => {
          const d = doc.data();

          // 1️⃣ filter by doctor
          if (d.doctorEmail !== doctorEmail) return;

          // 2️⃣ filter only requested
          if (d.status !== "requested") return;

          // 3️⃣ filter future dates
          const apptDate = new Date(`${d.appointmentDate}T00:00:00`);
          if (apptDate < todayDate) return;

          if (!allReq[d.appointmentDate]) {
            allReq[d.appointmentDate] = {};
          }

          allReq[d.appointmentDate][d.time] = {
            status: d.status,
            joinUrl: d.joinUrl,
            userEmail: d.userEmail,
          };

          if (d.userEmail === userEmail) {
            mySlot = {
              id: doc.id,
              date: d.appointmentDate,
              time: d.time,
              status: d.status,
              joinUrl: d.joinUrl,
            };
          }
        });

        setRequestedSlots(allReq);
        setUserCurrentRequest(mySlot);
      },
      (error) => {
        console.error("Firestore error:", error);
      }
    );

  return () => unsub();
}, [firebase, doctorEmail, userEmail]);

  /* ✅ GENERATE WEEK */
  const getWeekDates = () => {
    const dates = [];
    const start = new Date();
    start.setDate(today.getDate() + weekOffset * 7);

    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      dates.push(d);
    }
    return dates;
  };
  const weekDates = getWeekDates();

  const timeSlots = [
    "8:00 AM","9:00 AM","10:00 AM","11:00 AM",
    "12:00 PM","1:00 PM","2:00 PM","3:00 PM",
    "4:00 PM","5:00 PM","6:00 PM","7:00 PM","8:00 PM"
  ];

  const formatDateKey = (date) =>
    date.toISOString().split("T")[0];

  const isPastSlot = (date, time) => {
    const [t, mod] = time.split(" ");
    let [h] = t.split(":");
    h = parseInt(h);
    if (mod === "PM" && h !== 12) h += 12;
    if (mod === "AM" && h === 12) h = 0;

    const slotTime = new Date(date);
    slotTime.setHours(h, 0, 0, 0);
    return slotTime < new Date();
  };

  /* ✅ REQUEST SLOT */
  const requestAppointment = async (dateKey, time) => {
    const lockExists = requestedSlots?.[dateKey]?.[time];

    if (lockExists) {
      alert("This slot is already booked.");
      return;
    }

    if (
      userCurrentRequest &&
      userCurrentRequest.date === dateKey &&
      userCurrentRequest.time === time
    ) return;

    const batch = firebase.db.batch();

    if (userCurrentRequest) {
      const oldRef = firebase.db
        .collection("appointmentSchedules")
        .doc(userCurrentRequest.id);
      batch.delete(oldRef);
    }

    const newRef = firebase.db
      .collection("appointmentSchedules")
      .doc();

    batch.set(newRef, {
      userEmail,
      doctorEmail,
      appointmentDate: dateKey,
      time,
      status: "requested",
      createdAt: new Date()
    });

    try {
      await batch.commit();

const snapshot = await firebase.db
      .collection("PushNotificationTokens")
      .where("emailId", "in", [userEmail, doctorEmail])
      .get();   // ✅ IMPORTANT

    if (snapshot.empty) {
      console.log("No FCM tokens found for user");
      return;
    }
var message = "";
var count = 0;
    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      const fcmToken = data.fcmToken;
count++;
      if (!fcmToken) continue;
console.log(data)
      if(data.emailId == userEmail){
            message = "You’re one step closer to care. Your appointment request has been shared with your provider. We’ll notify you once it’s confirmed or if adjustments are needed."
        }else{
            message = "New appointment request awaiting your confirmation."
        }
debugger;
const response = await fetch(
    "https://sendushnotification-611486537983.us-east5.run.app",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: fcmToken,
        title: "Envue Health Appointment Notification",
        body: message,
      }),
    }
  );

  const dataResponse = await response.json().catch(() => null);

  if (response.ok) {
    if(count >= docSnap.data.length){
alert("Appointment requested successfully!");
      window.location.reload();
    }
    console.log("✅ Push notification sent successfully");
    console.log("Server response:", dataResponse);
  } else {
    console.error("❌ Push notification failed");
    console.error("Status:", response.status);
    console.error("Response:", dataResponse);
  }
    }


      
    } catch (err) {
      console.error(err);
      alert("Failed to request appointment");
    }
  };

  /* ✅ CLEAR ALL */
  const clearAll = async () => {
    if (!userCurrentRequest) {
      alert("You have no active request.");
      return;
    }

    try {
      await firebase.db
        .collection("appointmentSchedules")
        .doc(userCurrentRequest.id)
        .delete();

      alert("Your appointment request has been cleared.");
    } catch (err) {
      console.error(err);
      alert("Failed to clear request");
    }
  };

  return (
    <>
      <div style={styles.overlay}>
        <div style={styles.popupBox}>
          <div style={styles.card}>

            {/* ✅ HEADER */}
            <div style={styles.header}>
              <div>
                <div style={{ fontSize: "12px", opacity: 0.7 }}>
                  REQUEST APPOINTMENT
                </div>
                <div style={{ fontSize: "15px" }}>
                  {weekDates[0].toDateString()} – {weekDates[6].toDateString()}
                </div>
              </div>

              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <button style={topBtn} onClick={() => setWeekOffset(0)}>
                  ← Current Week
                </button>

                <button
                  style={topBtn}
                  onClick={() => setWeekOffset(weekOffset + 1)}
                >
                  Next Week →
                </button>

                <button
                  style={{ ...topBtn, background: "#b91c1c" }}
                  onClick={clearAll}
                >
                  Clear All
                </button>

                <button onClick={onClose} style={closeBtn}>✕</button>
              </div>
            </div>

            {/* ✅ GRID */}
            <div style={grid}>
              <div></div>

              {weekDates.map((d) => (
                <div key={d} style={dayHeader}>
                  {d.toDateString().slice(0, 10)}
                </div>
              ))}

              {timeSlots.map((time) => (
                <React.Fragment key={time}>
                  <div style={timeCell}>{time}</div>

                  {weekDates.map((date) => {
                    const dateKey = formatDateKey(date);
                    const isAvailable =
                      availableSlots?.[dateKey]?.[time];
                    const slotData =
                      requestedSlots?.[dateKey]?.[time];
                    const isPast = isPastSlot(date, time);

                    const isMyRequest =
                      userCurrentRequest?.date === dateKey &&
                      userCurrentRequest?.time === time;

                    return (
                      <div
                        key={dateKey + time}
                        onClick={() => {
                          if (slotData?.status === "confirmed" && isMyRequest) {
                            setConfirmedPopup({
                              ...slotData,
                              date: dateKey,
                              time
                            });
                          } else if (
                            isAvailable &&
                            !isPast &&
                            !slotData
                          ) {
                            requestAppointment(dateKey, time);
                          }
                        }}
                        style={{
                          ...slotCell,
                          cursor:
                            slotData?.status === "confirmed" && isMyRequest
                              ? "pointer"
                              : isAvailable && !isPast
                              ? "pointer"
                              : "not-allowed",
                          opacity: isPast ? 0.35 : 1
                        }}
                      >
                        {/* ✅ AVAILABLE */}
                        {isAvailable && !slotData && (
                          <div style={{
                            ...pill,
                            background:
                              "linear-gradient(135deg,#22c55e,#16a34a)"
                          }}>
                            Available
                          </div>
                        )}

                        {/* ✅ MY REQUEST */}
                        {isMyRequest && slotData?.status === "requested" && (
                          <div style={{
                            ...pill,
                            background:
                              "linear-gradient(135deg,#f59e0b,#d97706)"
                          }}>
                            My Request
                          </div>
                        )}

                        {/* ✅ CONFIRMED (CLICKABLE) */}
                        {isMyRequest && slotData?.status === "confirmed" && (
                          <div style={{
                            ...pill,
                            background:
                              "linear-gradient(135deg,#2563eb,#1d4ed8)"
                          }}>
                            Confirmed
                          </div>
                        )}

                        {/* ✅ LOCKED BY OTHER USER */}
                        {!isMyRequest && slotData && (
                          <div style={{
                            ...pill,
                            background:
                              "linear-gradient(135deg,#6366f1,#4338ca)"
                          }}>
                            Locked
                          </div>
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>

          </div>
        </div>
      </div>

      {/* ✅ CONFIRMED ZOOM POPUP */}
      {confirmedPopup && (
        <div style={styles.confirmOverlay}>
          <div style={styles.confirmPopupDark}>
            <h3 style={{ marginTop: 0 }}>Confirmed Appointment</h3>

            <p><b>Date:</b> {confirmedPopup.date}</p>
            <p><b>Time:</b> {confirmedPopup.time}</p>

            {confirmedPopup.joinUrl && (
              <p>
                <b>Zoom Link:</b>{" "}
                <a
                  href={confirmedPopup.joinUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#60a5fa", wordBreak: "break-all" }}
                >
                  Join Meeting
                </a>
              </p>
            )}

            <div style={styles.buttonRow}>
              <button
                style={styles.closeSecondaryBtn}
                onClick={() => setConfirmedPopup(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserScheduleAppointmentPopup;

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999
  },
  popupBox: {
    width: "95%",
    maxHeight: "90vh",
    overflowY: "auto",
    background: "rgba(0,0,0,0.6)",
    borderRadius: "10px"
  },
  card: {
    background: "#070d1b",
    borderRadius: "18px",
    padding: "24px",
    color: "#fff",
    margin: "20px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px"
  },
  confirmOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.85)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 100000
  },
  confirmPopupDark: {
    background: "#0b0f1a",
    padding: "22px",
    borderRadius: "12px",
    width: "360px",
    color: "#fff"
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "18px"
  },
  closeSecondaryBtn: {
    background: "#374151",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer"
  }
};

const topBtn = {
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.25)",
  color: "#fff",
  padding: "8px 12px",
  borderRadius: "10px",
  fontSize: "12px",
  cursor: "pointer"
};

const closeBtn = {
  background: "#dc2626",
  border: "none",
  color: "#fff",
  padding: "6px 10px",
  borderRadius: "50%",
  fontSize: "14px",
  cursor: "pointer"
};

const grid = {
  display: "grid",
  gridTemplateColumns: "90px repeat(7, 1fr)",
  gap: "10px"
};

const dayHeader = {
  textAlign: "center",
  fontSize: "12px",
  opacity: 0.8
};

const timeCell = {
  fontSize: "12px",
  opacity: 0.7
};

const slotCell = {
  height: "46px",
  borderRadius: "10px",
  background: "rgba(255,255,255,0.05)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const pill = {
  padding: "6px 12px",
  borderRadius: "999px",
  fontSize: "11px",
  color: "#fff"
};
